import React, { Component } from 'react'
import { Field, reduxForm } from 'redux-form'
import {
    Button, Col,
    Row, Form,
    FormGroup, Label,Input
} from 'reactstrap';
import { connect } from 'react-redux'
import Dropdown from '../View/Dropdown/index'
import * as createCaseActions from '../../../Analyst/Cases/Create/actions'
import { Preloading } from '../../../components/UI/Preloader/action';
import { setPageView, goolgeAnalyticsEvents } from '../../../components/GoogleAnalytics/index';
import { DOMESTIC, INTERNATIONAL, INDIA } from '../constant';
import * as portfolioConstant from '../../my-portfolio/constants'

class OtherReportForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            buyModalTypeFlag: false,
            disable: true,
            disablecounterParty: true,
            showModal: false,
            productsData: [],
            businessSegmentData: [],
            validation: null,
            productFetch : true,
            selectedProduct : undefined,
            selectedCounterpartyType : undefined,
            defaultZone : undefined,
            selectedBusinessSegment:undefined,
            pan:undefined,
            cinNo:undefined,
            otherEnquiryDetails:'',
            
        };
        this.data = [];
        this.newProp = "";
        this.newProduct = "";
        this.status = "";
        this.error = "";
    
    }

    componentDidMount(){
        setPageView('/Corporate/OtherReportBuyForm', document.location.href);
        if(!this.props.zoneForState){
            this.props.getZoneList();
         } 
         if (this.props.buyFormType === 'PORTFOLIO_BUY') {
            this.props.preloading(true);
            this.props.handleResizeZIndex(true);
            this.props.getProducts(this.props.userDetails.corporateId, this.props.selectedvalue, this.props.selectedProductCategory, portfolioConstant.OTHERS)
         }
         else if (this.props.buyFormType === 'GLOBAL_SEARCH_RESULT_BUY') {
            this.props.getCounterpartyType();
        }
        this.props.getAllDivisionSubsidiary(this.props.userDetails.corporateId);
    }

    componentDidUpdate(prevProps){
        if (prevProps.buyFormType !== this.props.buyFormType) {
        if (this.props.buyFormType === 'PORTFOLIO_BUY') {
            this.setState({
                buyModalTypeFlag: true
            })
        }else {
            this.setState({
                buyModalTypeFlag: false
            })
        }
        };
        const { counterpartyTypeSelected, getProducts } = this.props
        if(this.props.counterpartyType != prevProps.counterpartyType && this.props.counterpartyType && this.props.counterpartyType.length > 0 && this.state.productFetch){
            this.props.getProducts(this.props.userDetails.corporateId, this.props.counterpartyType[0], this.props.selectedProductCategory, portfolioConstant.OTHERS);
            this.setState({productFetch : false, selectedCounterpartyType : this.props.counterpartyType[0]});
        }
        if(this.props.zoneList != prevProps.zoneList && this.props.zoneList && this.props.zoneList.length>0){
            this.setState({defaultZone: this.props.zoneList[0]});
        }

        if (counterpartyTypeSelected && counterpartyTypeSelected.values && counterpartyTypeSelected !== prevProps.counterpartyTypeSelected) {
            
            this.setState({
                disable: false
            })
            if (this.props.buyFormType !== 'PORTFOLIO_BUY') {
                if (counterpartyTypeSelected.values.counterpartytype !== undefined && (prevProps.counterpartyTypeSelected.values === undefined || prevProps.counterpartyTypeSelected.values.counterpartytype === undefined)) {
                    this.props.preloading(true);
                    this.props.handleResizeZIndex(true);
                    getProducts(this.props.userDetails.corporateId,
                        counterpartyTypeSelected.values.counterpartytype, this.props.selectedProductCategory, portfolioConstant.OTHERS)
                }
                else if (counterpartyTypeSelected.values.counterpartytype && prevProps.counterpartyTypeSelected.values !== undefined && prevProps.counterpartyTypeSelected.values.counterpartytype && counterpartyTypeSelected.values.counterpartytype !== prevProps.counterpartyTypeSelected.values.counterpartytype) {
                    this.props.preloading(true);
                    this.props.handleResizeZIndex(true);
                    getProducts(this.props.userDetails.corporateId,
                        counterpartyTypeSelected.values.counterpartytype, this.props.selectedProductCategory, portfolioConstant.OTHERS)
                }
            }
        }
        if (this.props.products !== prevProps.products ) {
            if(this.props.products.length>0){
                this.setState({
                    productsData: this.props.products,
                    disable: false,
                    selectedProduct : this.props.products[0].id
                })
            }
            else{
                this.setState({
                    productsData: this.props.products,
                    disable: false,
                    selectedProduct : null
                })
            }
            this.props.preloading(false);
            this.props.handleResizeZIndex(false);
        }
        if(this.props.allDivisionSubsidiary!=prevProps.allDivisionSubsidiary){
            this.setState({
                businessSegmentData: this.props.allDivisionSubsidiary,
                disable: false,
                selectedBusinessSegment : this.props.allDivisionSubsidiary[0].id
            })
        }
        if (this.props.buyFormType !== prevProps.buyFormType) {
        }

    }

    resetForm =()=> {
        this.setState({otherEnquiryDetails:''})
    }

    mySubmitHandler = (data) => {
        let tempCoporateId,
            tempRequestedById, caseType, zoneSelectedId;
        if (this.props.selectedCounterParty.corporateId && this.props.selectedCounterParty.corporateUserId) {
                tempCoporateId = this.props.selectedCounterParty.corporateId;
                tempRequestedById = this.props.selectedCounterParty.corporateUserId
        } else {
            tempCoporateId = null;
            tempRequestedById = null;
        }
        if (this.props.selectedCounterParty.country === INDIA) {
            caseType = DOMESTIC
        } else {
            caseType = INTERNATIONAL
        }
        if(this.props.zoneForState){
            zoneSelectedId = this.props.zoneForState.zoneId
         }
        else{
            zoneSelectedId = data.zone ? data.zone : this.state.defaultZone.id
        }

        this.case ={
            "productId": data.product ? data.product : this.state.selectedProduct ,
            "corporateId": data.businessSegment? data.businessSegment : this.state.selectedBusinessSegment,
            "requestedById": tempRequestedById,
            "caseType": caseType,
            "otherEnquiryDetails":this.state.otherEnquiryDetails,
            "requestType":"CLIENT_PORTAL"

        }
        if (this.props.selectedCounterParty.counterpartyId) {
            this.case = {
                ...this.case,
                "counterpartyId": this.props.selectedCounterParty.counterpartyId,
            }
            if (this.props.buyFormType === 'PORTFOLIO_BUY') {
                this.case = {
                    ...this.case,
                    "counterpartyType":  this.props.selectedvalue,
                   // "zoneId": this.props.zoneSelected[0].id,
                   "zoneId": zoneSelectedId,
                }
            } else {
                this.case = {
                    ...this.case,
                    "counterpartyType": data.counterpartytype ? data.counterpartytype : this.state.selectedCounterpartyType,
                    "zoneId": zoneSelectedId,
                }
            }
            goolgeAnalyticsEvents('Corporate', 'Create Case For Selected Counterparty From Global Search', 'Create Case', '');
            this.props.createCase(this.case)
        } else {
            let tempDataSelected = [];
            this.props.selectedValueData.forEach((selectedCheckboxData, index, element) => {
               this.props.zoneSelected.forEach((zone, i, zoneData) => {
                    if (zone.name === selectedCheckboxData.zoneName) {
                        tempDataSelected.push({
                            counterpartyId: selectedCheckboxData.counterpartyId,
                            zoneId: zone.id
                        })
                    }

                })
            })
            this.case = {
                ...this.case,
                "caseBulkRequestMetadataList": tempDataSelected,
                "counterpartyType": this.props.selectedvalue
            }
            this.props.createBulkBuy(this.case);
        }
        this.resetForm()
        this.props.preloading(true)
        this.props.toggle()
    }
    onchangeComment = (e)=>{

        if(e){
            e.persist();
            this.setState ({
                otherEnquiryDetails: e.target.value
            })
        }
    }

    handleCancel = () => {
        this.props.toggle()
    }

    render (){
        const { handleSubmit } = this.props;
        
            return (
                <Form onChange={this.handleFormChange} onSubmit={handleSubmit((val) => { this.mySubmitHandler(val) })} autoComplete="on">
                    <FormGroup>
                        <Label>Name</Label>
                        <Row>
                            <Col>
                                <Input
                                    name="address"
                                    label="address"
                                    component="renderField"
                                    type='text'
                                    className="form-control"
                                    disable={true}
                                    value={this.props.selectedCounterParty.counterpartyName}
                                />
                                
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Label>Address</Label>
                        <Row>
                            <Col>
                                <Input
                                    name="address"
                                    label="address"
                                    component="renderField"
                                    type='text'
                                    className="form-control"
                                    disable={true}
                                    value={this.props.selectedCounterParty.address}
                                />
                                
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Label>PanNo</Label>
                        <Row>
                            <Col>
                                <Input
                                    name="address"
                                    label="address"
                                    component="renderField"
                                    type='text'
                                    className="form-control"
                                    disable={true}
                                    value={this.props.selectedCounterParty.panNo}
                                />
                                
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Label>CinNo</Label>
                        <Row>
                            <Col>
                                <Input
                                    name="address"
                                    label="address"
                                    component="renderField"
                                    type='text'
                                    className="form-control"
                                    disable={true}
                                    value={this.props.selectedCounterParty.cinNo}
                                />
                                
                            </Col>
                        </Row>
                    </FormGroup>
                    
                    <FormGroup>
                        <Label>Counterparty Type</Label>
                        <Row>
                            <Col>
                                <Field 
                                    name="counterpartytype"
                                    // component="select"
                                    label="dropDownSelect"
                                    component={Dropdown}
                                    validate={this.state.validation}
                                    className="form-control"
                                    defaultValue = {this.props.selectedvalue}
                                    selectedValue={this.props.selectedvalue}
                                    data={this.props.counterpartyType}
                                    dis={this.state.buyModalTypeFlag}
                                    type={this.props.buyFormType}
                                >
                                    {/* {people.map(DropDownSelect)} */}
                                </Field>
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Label>Product</Label>
                        <Row>
                            <Col>
                                <Field
                                    name="product"
                                    label="dropDownSelect"
                                    component={Dropdown}
                                    className="form-control"
                                    defaultValue = {this.state.selectedProduct}
                                    data={this.state.productsData}
                                    dis={this.state.disable}
                                >
                                </Field>
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Label>Business Segment</Label>
                        <Row>
                            <Col>
                                <Field
                                    name="businessSegment"
                                    label="dropDownSelect"
                                    component={Dropdown}
                                    className="form-control"
                                    defaultValue = {this.state.selectedBusinessSegment}
                                    data={this.state.businessSegmentData}
                                    dis={this.state.disable}
                                >
                                </Field>
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Label>Credit Deducted</Label>
                        <Row>
                            <Col>
                                <Input
                                    name="CreditDeducted"
                                    label="CreditDeducted"
                                    component="renderField"
                                    type='text'
                                    className="form-control"
                                    readOnly={true}
                                    //value={this.props.selectedCounterParty}
                                />    
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup >
                         <Label>Comment</Label>
                         <Row className='d-flex'>
                           <Col>
                                <Input 
                                   type="text"
                                   name="Comment" 
                                   id="Comment" 
                                   placeholder="Add comment here" 
                                   onChange={ (e)=>this.onchangeComment(e)} 
                                   value={this.state.otherEnquiryDetails}
                                />
                        </Col>
                     </Row>
                    </FormGroup>    

                    <Button color="primary" type="submit" id="buySubmit" className="mt-5">Submit</Button>
                    <Button color="danger" type="button" id="buyCancel" className="mt-5 ml-5" onClick={this.handleCancel}>Cancel</Button>
                </Form>

            )
        
        }
}


const required = value => value ? undefined : 'Required';

const mapStateToProps = (state, ownProps) => ({
    userDetails: state.loginDetails.userDetails,
    products: state.createCase.products,
    allDivisionSubsidiary:state.createCase.allDivisionSubsidiary,
    zoneList: state.createCase.zoneList,
    counterpartyType: state.createCase.dropdownData,
    counterpartyTypeSelected: state.form.OtherReportForm,
    selectedCounterParty: state.corporate.selectedCounterParty,
})

const mapDispatchToProps = (dispatch) => ({

    getCounterpartyType: () => { dispatch(createCaseActions.getCounterpartyType()) },
    getZoneList: () => { dispatch(createCaseActions.getZone()) },
    getProducts: (corporateId, type,selectedProductCategory, reportCategory) => { dispatch(createCaseActions.getProducts(corporateId, type,selectedProductCategory, reportCategory)) },
    getAllDivisionSubsidiary:(corporateId)=>{dispatch(createCaseActions.getAllDivisionSubsidiary(corporateId))},
    createCase: (data) => { dispatch(createCaseActions.createCase(data)) },
    createBulkBuy: (data) => { dispatch(createCaseActions.createBulkBuy(data)) },
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); }
});

export default reduxForm({
    form: 'OtherReportForm'
})(connect(mapStateToProps, mapDispatchToProps)(OtherReportForm))//
